module.exports = __webpack_public_path__ + "img/TITLE-05.22b9e022.png";